import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import SimpleBar from 'simplebar';

class CustomScroll extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  didMount() {
    new SimpleBar(this.element, CustomScroll.defaultProps);
  }
  willUnMount() {}
  update() {}
}

CustomScroll.defaultProps = {
  autoHide: false,
};

export default CustomScroll;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CustomScroll.js